/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {Link} from 'react-router';
import ScrollArea from '../../../../ScrollArea';
import {VelocityComponent} from 'velocity-react';
import Classnames from 'classnames';
import Tooltip from 'rc-tooltip';

import {StubFunc, getScroll} from '../../../../../utils';
import {FetchAssetById} from '../../../../../actions/asset/action-asset';
import {SetPlayer, OpenMessage} from '../../../../../actions/common/actions-common';
import {SetSettingsState} from '../../../../../actions/common/actions-common';
import {AddToFavorites, RemoveFromFavorites} from '../../../../../actions/favorites/actions-favorites';
import {ACTIONS} from '../../../../../containers/Player';

import DivLoader from '../../../../DivLoader';
import Translate from '../../../../Translate';
import Ratings from '../../Widgets/Ratings';
import Episode from '../../Widgets/Episode';
import Share from '../../Widgets/Share';
import MultiscreenDevices from '../../Widgets/MultiscreenDevices';

import _get from 'lodash/get';
import _concat from 'lodash/concat';
import _find from 'lodash/find';

class TvSeriesProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: Config.white_skin ? '' : `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`,
      streamUrl: '',
      isPlayerShowed: false,
      streamCategory: null,
      showUserDevices: false,
      selectedSeason: null,
      selectedEpisode: null
    };
  }

  componentDidMount() {

    this._fetchTvSeriesAssetData(_get(this.props, 'tvSeriesId', null));

    if (this.props.tvSeries.id) {

      lh.models.asset.methods
        .getPosterUrl(this.props.tvSeries, {
          crop: {x: 185, y: 270},
          cache: false
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: Config.white_skin ? '' : `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`});
        });
    }
  }

  componentWillReceiveProps(newProps) {

    if (this.props.tvSeriesId !== newProps.tvSeriesId) {
      this._onCloseEpisode();
      this._stopPlayback();

      this.setState({
        selectedSeason: null,
        picture: Config.white_skin ? '' : `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`,
        streamCategory: null,
        showUserDevices: false
      });

      this._fetchTvSeriesAssetData(_get(newProps, 'tvSeriesId', null));
    }

    if (newProps.tvSeries.id && newProps.tvSeries.id !== this.props.tvSeries.id) {

      lh.models.asset.methods
        .getPosterUrl(newProps.tvSeries, {
          crop: {x: 185, y: 270},
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: Config.white_skin ? '' : `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`});
        });
    }
  }

  componentWillUnmount() {

    this._stopPlayback();
  }

  _fetchTvSeriesAssetData(tvSeriesId) {
    this.props.FetchAssetById(tvSeriesId, 'tv_series');

  };

  _hasTrailer() {

    return !!_find(this.props.tvSeries.resources, {type: 'stream', category: 'trailer'});
  }

  _addToFavorites() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.AddToFavorites(this.props.tvSeries.id);
  }

  _removeFromFavorites() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.RemoveFromFavorites(this.props.tvSeries.id);
  }

  _toggleDevices(state) {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.setState({showUserDevices: state});
  };

  _closeProfile() {

    this.props.onClose();
    this._stopPlayback();
  }

  _startPlayback(ep, type) {

    if (this.props.user.user === 'guest' && type !== 'trailer_hls') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    if (!this.props.tvSeries.is_purchased && !this.props.tvSeries.is_available && !this.props.tvSeries.is_free && type !== 'trailer_hls') {

      this._showOffers();
      return;
    }

    if (type === 'vod_hls' && ep) {

      lh.models.viewAsset.methods.getStreamUrl(ep)
        .then((stream) => {
          let position = this.props.startFromPosition;

          this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: 'vod_hls'});

          this.props.SetPlayer({
            stream_url: stream,
            position: position,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            //type: 'clpp',
            type: 'rmp',
            stream_type: type,
            monitoring: {
              assetTitle: ep.title,
              assetID: ep.id,
              type: 'episode'
            },
            get_url_again_fn: lh.models.viewAsset.methods.getStreamUrl.bind(this, ep)
          });
        }, this._processStreamError);
    }
  }

  _stopPlayback() {

    this.setState({isPlayerShowed: false});
    this.props.SetPlayer({
      stream_url: '',
      container: null,
      action: ACTIONS.CLOSE,
      monitoring: null
    });
  }

  _showOffers() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.OpenMessage({
      type: 'offers',
      asset_id: this.props.tvSeries.id,
      actions: [
        {
          title: 'no_thanks',
          func: () => {
          }
        }
      ]
    });
  }

  _onSeasonSelect(season) {

    this.setState({
      selectedSeason: season
    });
  }

  _onEpisodeSelect(episode) {

    this.setState({
      selectedEpisode: episode
    });

    this._stopPlayback();
  }

  _onCloseEpisode() {

    this.setState({
      selectedEpisode: null
    });

    this._stopPlayback();
  }

  _processStreamError = (reason) => {
    if (_get(reason, 'message') === 'subscriber blocked') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'blocker',
      });
    } else if (_get(reason, 'message') === 'the requested content is not available in your geographical location') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.GEO_BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'geo-blocker',
      });
    } else {
      //TODO: SHOW ERROR CODE
      console.log('Failed:', reason);
    }
  };

  _renderOffers() {
    if (!this.props.tvSeries.offers || !this.props.tvSeries.offers.length) return <noscript />;

    if (this.props.tvSeries.is_purchased) {

      return <noscript />;
    }

    if (!this.props.tvSeries.is_available && this.props.tvSeries.is_free) {

      return <div className="profile-bigtext"><Translate content="profile.offers.type.free" /></div>;
    }

    return this.props.tvSeries.offers.map(function (offer, index) {

      if (offer.type === 'transactional') {
        if (_get(offer, 'right_params.duration') === 0) {
          offer._typeParsed = 'transactional-own';
        } else {
          offer._typeParsed = 'transactional-rent';
        }
      } else {
        offer._typeParsed = offer.type;
      }

      return (
        <div className="offer" key={'offer_' + offer.id + '_' + index}>
          <div className="offer-type color-grey">
            <Translate content={`profile.offers.type.${_get(offer, '_typeParsed', '_')}`} />
            {(offer.is_from_package) ?
              <Tooltip
                placement="top"
                destroyTooltipOnHide={true}
                overlay={
                  <div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
                    <Translate content="profile.tvSeries.bundle" />: {offer.parent.title || ''}
                  </div>}>
                <i className="ml- ic ic-tickets"></i>
              </Tooltip>
              : ''}
          </div>
          <div className="offer-price pointer">
            <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
            <span>{_get(offer, 'billing_params.price') / 100}</span>
            {(_get(offer, 'type') === 'subscription') ?
              ('/' + (_get(offer, 'right_params.duration') > 1 ?
              _get(offer, 'right_params.duration') + ' ' : '') + _get(offer, 'right_params.duration_unit') + '(s)')
              : ''}
          </div>
        </div>
      );
    });
  }

  _renderSeasons() {

    return _get(this.props, 'tvSeries.tv_series_seasons', []).map((season, index) => {
      const seasonClasses = Classnames({
        'color-grey': season.id !== _get(this.state, 'selectedSeason.id'),
        'pointer': true
      });

      return (
        <div key={'season_' + season.index + '_' + index} className={seasonClasses} onClick={this._onSeasonSelect.bind(this, season)}>
          <Translate content="profile.tvSeries.season_short" />{season.index}. {season.title}
        </div>
      );
    });
  }

  _renderEpisodes() {

    if (!this.state.selectedSeason) {

      return null;
    }

    return _get(this.state.selectedSeason, 'episodes2', []).map((episode, index) => {
      const episodeClasses = Classnames({
        'color-grey': episode.id !== _get(this.state, 'selectedEpisode.id'),
        'pointer': true
      });

      return (
        <div key={'episode_' + episode.index + '_' + index} className={episodeClasses} onClick={this._onEpisodeSelect.bind(this, episode)}>
          <Translate content="profile.tvSeries.episode_short" />{episode.index}. {episode.title}
        </div>
      );
    });
  }

  render() {
    if (!this.props.tvSeries.id) return <div className="profile movie-inf-example movie-inf-profile bg-black radius"><DivLoader loading={true} /></div>;

    return (<div className="profile movie-inf-example movie-inf-profile bg-black radius">
      <DivLoader loading={this.props.inProgress} />
      <Episode episodeId={_get(this.state, 'selectedEpisode.id')}
               onStartPlayback={this._startPlayback.bind(this)} onStopPlayback={this._stopPlayback.bind(this)}
               onClose={this._onCloseEpisode.bind(this)} isPlayerShowed={this.state.isPlayerShowed} />
      <VelocityComponent animation={{left: this.state.isPlayerShowed ? '271px' : 0}} duration={500}>
        <div className="profile-cols relative">
          <div className="block-2 relative">
            <div className="profile-poster slider-pause">
              <div className="crow no-gutter">
                <img id="profile_poster" src={this.state.picture} alt="" />
              </div>
            </div>
          </div>
          <div className="block-2">
            <div className="profile-descr pr">
              <div className="profile-title">
                {_get(this.props.tvSeries, 'title', '')}
              </div>
              <Ratings ratings={this.props.tvSeries.ratings} />
              <ScrollArea
                speed={0.8}
                className="profile-text"
                horizontal={false}
                smoothScrolling={true}>
                <div>
                  {_get(this.props.tvSeries, 'description', '')}
                </div>
              </ScrollArea>
            </div>
          </div>
          <div className="block-2">
            <div className="profile-seasons-wrapper">
              <div className="color-grey"><Translate content="profile.tvSeries.seasons" />:</div>
              <ScrollArea
                speed={0.8}
                className="profile-seasons pr"
                horizontal={false}
                smoothScrolling={true}>
                <div>
                  {this._renderSeasons()}
                </div>
              </ScrollArea>
            </div>
            {!!this.state.selectedSeason && <div className="profile-episodes-wrapper">
              <div className="color-grey"><Translate content="profile.tvSeries.episodes" />:</div>
              <ScrollArea
                speed={0.8}
                className="profile-episodes pr"
                horizontal={false}
                smoothScrolling={true}>
                <div>
                  {this._renderEpisodes()}
                </div>
              </ScrollArea>
            </div>}
          </div>
          <VelocityComponent animation={this.state.isPlayerShowed && this.state.streamCategory !== 'trailer_hls' ? 'fadeOut' : 'fadeIn' } duration={500}>
            <div className="block-1">
              { !this.props.tvSeries.is_purchased && !this.props.tvSeries.is_available &&
              <div className="profile-r pr purchase-container">
                <ScrollArea
                  speed={0.8}
                  className="offers-wrapper"
                  horizontal={false}
                  smoothScrolling={true}>
                  {this._renderOffers()}
                </ScrollArea>
                {!this.props.tvSeries.is_free && <div className="purchase-ico mt hover" onClick={this._showOffers.bind(this)}>
                  <i className="ic ic-shopping-cart"></i>
                </div>}
              </div>}
            </div>
          </VelocityComponent>
          <VelocityComponent animation={this.state.isPlayerShowed ? 'fadeOut' : 'fadeIn' } duration={500}>
            <div className="block-1">
              <div className="profile-r">
                <div className="profile-actions pr">
                  <div className="mt-">
                    <div className="color-grey pv-"><Translate content="profile.tvSeries.related" /></div>
                    <div>
                      <Link to={'/related/' + this.props.tvSeries.id} className="hover">
                        <i className="ic ic-vod-related ic-24px"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </VelocityComponent>
          <div className="block-1 col-last">
            <div className="profile-r">
              <div className="profile-actions pr">
                {!this.props.tvSeries.is_favorite ?
                  <div>
                    <div className="color-grey pv-"><Translate content="profile.tvSeries.fav_add" /></div>
                    <div id="favorite"><a className="hover" onClick={this._addToFavorites.bind(this)}>
                      <i className="ic ic-fav-in ic-18px"></i>
                    </a></div>
                  </div>
                  :
                  <div>
                    <div className="color-grey pv-"><Translate content="profile.tvSeries.fav_remove" /></div>
                    <div id="favorite"><a className="hover" onClick={this._removeFromFavorites.bind(this)}>
                      <i className="ic ic-fav-in-fill ic-18px"></i>
                    </a></div>
                  </div>
                }
                {/*{Config.multiscreen_allowed &&*/}
                {/*<div className="mt-">*/}
                {/*<div className="color-grey pv-"><Translate content="profile.tvSeries.multiscreen" /></div>*/}
                {/*<div id="screen">*/}
                {/*<a className="hover share-to-device" onClick={this._toggleDevices.bind(this, true)}>*/}
                {/*<i className="ic ic-multiscreen ic-24px"></i>*/}
                {/*</a>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*}*/}
                <div className="mt-">
                  <Share contentUrl={`${location.origin}/asset/${this.props.tvSeries.id}`} />
                </div>
              </div>
            </div>
            {Config.multiscreen_allowed && <MultiscreenDevices asset={this.props.tvSeries} show={this.state.showUserDevices} onClose={this._toggleDevices.bind(this, false)} />}
          </div>
        </div>
      </VelocityComponent>
      <a className="mw-close ico ico-close slider-resume pointer" onClick={this._closeProfile.bind(this)}></a>
    </div>);
  }
}

//TODO: initSeason, initEpisode
TvSeriesProfile.propTypes = {
  initSeason: PropTypes.number,
  initEpisode: PropTypes.number,
  tvSeriesId: PropTypes.number.isRequired,
  tvSeries: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  inProgress: PropTypes.bool.isRequired
};

TvSeriesProfile.defaultProps = {
  onClose: StubFunc.bind(this, 'onClose from tvSeries Profile')
};

const mapStateToProps = function ({assets, auth: {user}, common: {player}}, ownProps) {
  let asset = _get(assets, _get(ownProps, 'tvSeriesId', null), {});

  return {
    user: user,
    tvSeries: asset,
    inProgress: !!asset._fetchInProgress,
    playerIsDetached: !!player.isDetached
  }
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({
    FetchAssetById,
    SetPlayer,
    OpenMessage,
    SetSettingsState,
    AddToFavorites,
    RemoveFromFavorites
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TvSeriesProfile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Types/TvSeries/tv-series-profile.js